import React, { memo } from 'react'
import numbersStyles from '../../styles/tracker-modules/bignumbers.module.less'

function getClassName(style) {
  switch (style) {
    case 'partial':
      return numbersStyles.partially
    case 'topper partial':
      return numbersStyles.topperPartially
    case 'fully':
      return numbersStyles.fully
    case 'topper fully':
      return numbersStyles.topperFully
    case 'available':
      return numbersStyles.available
    default:
      return numbersStyles.default
  }
}

const BigNumber = ({ number, label, style, subhed }) => {
  return (
    <div className={`${getClassName(style)} ${numbersStyles.container}`}>
      <p className={numbersStyles.numbers}>
        <span>{number}</span>
      </p>
      {subhed && <p className={numbersStyles.subhed}>{subhed}</p>}
      <p className={numbersStyles.words}>{label}</p>
    </div>
  )
}

export default memo(BigNumber)
